var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_663_5420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 23.2185C46 10.5161 35.7024 0.218536 23 0.218536C10.2976 0.218536 0 10.5161 0 23.2185C0 34.0046 7.42624 43.0556 17.4441 45.5414V30.2473H12.7015V23.2185H17.4441V20.1899C17.4441 12.3616 20.987 8.73314 28.6727 8.73314C30.13 8.73314 32.6444 9.01926 33.6729 9.30446V15.6755C33.1301 15.6184 32.1871 15.5899 31.016 15.5899C27.2449 15.5899 25.7876 17.0187 25.7876 20.7327V23.2185H33.3003L32.0096 30.2473H25.7876V46.0502C37.1763 44.6748 46.0009 34.978 46.0009 23.2185H46Z",
    fill: "#0866FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0086 30.2473L33.2994 23.2185H25.7867V20.7327C25.7867 17.0186 27.244 15.5899 31.015 15.5899C32.1862 15.5899 33.1292 15.6184 33.672 15.6754V9.30444C32.6434 9.01832 30.1291 8.73312 28.6718 8.73312C20.9861 8.73312 17.4432 12.3616 17.4432 20.1899V23.2185H12.7006V30.2473H17.4432V45.5414C19.2225 45.983 21.0836 46.2185 22.9991 46.2185C23.9421 46.2185 24.8722 46.1606 25.7858 46.0502V30.2473H32.0077H32.0086Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_663_5420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(0 0.218536)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0a4f703025f8c9851e51fecbb01ccf51.svg";
export { ForwardRef as ReactComponent };